import { css, cx } from '@emotion/css';
import { MONO_FONT_FAMILY } from '@medcom/shared-ui/styles/globalCss.ts';
import { theme } from 'antd';
import { useMemo } from 'react';
import type { LabResultState } from '../../../generated/openapi/befunde-api';
import { labResultStateColor } from '../../../labresultstate/mapLabResultState.ts';

export const usePagedBefundeListStyles = () => {
  const { token } = theme.useToken();

  return useMemo(
    () => ({
      befundListItem: (selected: boolean, labResultStatus: LabResultState) =>
        cx(
          css`
            border-radius: ${token.borderRadius}px;
            border-block-end: none !important;

            .ant-list &.ant-list-item {
              padding: ${token.padding}px ${token.paddingXS}px ${token.padding}px ${token.paddingXS}px;
            }

            .ant-list &.ant-list-item .ant-list-item-meta {
              border-left: 4px solid ${labResultStateColor(token, labResultStatus)};
              padding-left: ${token.paddingXS}px;
            }
            .ant-list &.ant-list-item .ant-list-item-meta .ant-list-item-meta-title {
              margin-bottom: 0;
            }
          `,
          {
            [css`
              background-color: ${token.controlItemBgActiveHover};
            `]: selected,
          }
        ),
      leftRight: css`
        display: flex;
        flex-direction: row;
        gap: ${token.paddingXS}px;
        align-items: center;
      `,
      name: css`
        font-weight: bold;
        flex-grow: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      `,
      orderSvnr: css`
        flex-grow: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: ${MONO_FONT_FAMILY};
      `,
      rightItem: css`
        align-content: end;
        color: ${token.colorTextDescription};
        font-weight: lighter;
        font-variant-numeric: tabular-nums;
      `,
    }),
    [token]
  );
};
